import {ProcedureType, StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {logProfilerTimingEvent} from 'performance/BenchlingProfiler';
import {
  STUDIES_ADD_CONDITIONS_STARTED_EVENT,
  STUDIES_ADD_CONDITIONS_ENDED_EVENT,
  composeStudiesAddConditionsEventMetadata,
  ExecutionType,
} from 'performance/processStudiesEvents';
import {updateProcedureRun, UpdateProcedureRunParams} from 'procedures/network/ProcedureRunDAO';
import {OnUnknownErrorAction} from 'studies/sidepanel/CreationTrayTask';
import {getProcedureRunConditionTextForProcedureType} from 'studies/TypedStudyUtils';
import {withLoadingScreen} from 'util/Promises';

import {showConditionCreationTrayTask} from './ConditionCreationTrayTask';

export async function onAddConditions(
  studyId: string,
  procedureType: ProcedureType,
  studyType: StudyType,
  update: UpdateProcedureRunParams,
  callbacks: {
    onSuccess: () => void;
    onOpen: () => void;
    onUnknownError: OnUnknownErrorAction;
  }
): Promise<void> {
  logProfilerTimingEvent(STUDIES_ADD_CONDITIONS_STARTED_EVENT);
  const initResponse = await withLoadingScreen(
    updateProcedureRun(update, {supportsAsync: true}),
    `Adding ${getProcedureRunConditionTextForProcedureType(procedureType, {plural: update.newConditions && update.newConditions.length > 1})}...`
  );
  if (!initResponse.async) {
    callbacks.onSuccess();
    callbacks.onOpen();
    logProfilerTimingEvent(
      STUDIES_ADD_CONDITIONS_ENDED_EVENT,
      composeStudiesAddConditionsEventMetadata(studyType, ExecutionType.SYNC)
    );
    return;
  }

  showConditionCreationTrayTask(
    initResponse.data.taskId,
    initResponse.data.status_url,
    initResponse.taskMeta,
    [
      {
        id: update.id,
        studyId,
        procedureType,
        studyType,
        numNewConditions: update.newConditions?.length ?? 0,
      },
    ],
    {
      onSuccess: (response) => {
        callbacks.onSuccess();
        logProfilerTimingEvent(
          STUDIES_ADD_CONDITIONS_ENDED_EVENT,
          composeStudiesAddConditionsEventMetadata(studyType, ExecutionType.ASYNC)
        );
      },
      onOpen: callbacks.onOpen,
      onUnknownError: callbacks.onUnknownError,
    },
    initResponse.data.timingMeta
  );
}
